var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 13.333A6.25 6.25 0 0 1 10 7.083h20a6.25 6.25 0 0 1 6.25 6.25v7.5a1.25 1.25 0 1 1-2.5 0v-2.916H6.25v8.75a3.75 3.75 0 0 0 3.75 3.75h10a1.25 1.25 0 0 1 0 2.5H10a6.25 6.25 0 0 1-6.25-6.25zm3.598-2.652A3.75 3.75 0 0 1 10 9.583h20a3.75 3.75 0 0 1 3.75 3.75v2.084H6.25v-2.084a3.75 3.75 0 0 1 1.098-2.652",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.417 31.667c0-.69.56-1.25 1.25-1.25h6.982l-2.866-2.866a1.25 1.25 0 1 1 1.768-1.768l5 5a1.25 1.25 0 0 1 .366.884zM33.649 32.917h-6.982c-.69 0-1.25-.56-1.25-1.25zM33.649 32.917l4.268-1.239a1.25 1.25 0 0 1-.366.873l-5 5a1.25 1.25 0 0 1-1.768-1.768zM10.425 25c0-.69.56-1.25 1.25-1.25h.008a1.25 1.25 0 1 1 0 2.5h-.008c-.69 0-1.25-.56-1.25-1.25M18.333 23.75a1.25 1.25 0 0 0 0 2.5h3.334a1.25 1.25 0 1 0 0-2.5z"
  })));
};
export default SvgCard;